// translations.js - Multi-language content for Montana Y Sol

export const translations = {
  de: {
    nav: {
      highlights: "Highlights",
      impressionen: "Impressionen", 
      lage: "Lage",
      kontakt: "Kontakt",
      projekt: "Projekt"
    },
    hero: {
      title: "Montana Y Sol",
      subtitle: "Dein Sehnsuchtsort",
      description: "Exklusives Wohnen im ursprünglichen Andratx, nur wenige Minuten von den wunderschönen Buchten Mallorcas entfernt.",
      cta: "Entdecken",
      location: "Andratx, Mallorca",
      playVideo: "Video abspielen",
      priceRequest: "Preis auf Anfrage"
    },
    about: {
      label: "Über das Projekt",
      title: "Montana Y Sol",
      p1: "Montana Y Sol befindet sich im ursprünglichen Ort Andratx, nur wenige Minuten von wunderschönen Buchten und Stränden Mallorcas entfernt. Das Projekt bietet ein Bergpanorama und ist von blühenden Gärten und grünen Wäldern umgeben.",
      p2: "Es ist der perfekte Ort für Sport und Abenteuer, wie Radfahren, Wandern und Golf, sowie Wassersport und Tauchen. Hier können Sie das echte Mallorca erleben und die Gastfreundschaft der Einheimischen genießen.",
      p3: "Montana Y Sol wird nachhaltig betrieben und ist perfekt in die mallorquinische Lebensart eingepasst.",
      cta: "Mehr erfahren"
    },
    highlights: {
      label: "Warum Montana Y Sol",
      title: "Der ultimative",
      titleHighlight: "Sehnsuchtsort",
      items: [
        {
          number: "01",
          title: "Authentisches Inselleben",
          description: "Erleben Sie das echte Mallorca und genießen Sie die Gastfreundschaft der Einheimischen. Montana Y Sol befindet sich inmitten des beliebten Süd-Westen der Insel und bietet einen Einblick in die Kultur und Traditionen Mallorcas."
        },
        {
          number: "02", 
          title: "Ein Ort nahe am Meer",
          description: "Entspannen Sie am Meer und genießen Sie die sauberen Buchten, Strände und das glasklare Wasser. Unser Bauprojekt liegt nur wenige Autominuten von den einzigartigen Buchten und Stränden entfernt."
        },
        {
          number: "03",
          title: "Ein Ort für Abenteuer",
          description: "Erkunden Sie die Insel auf dem Fahrrad, gehen Sie wandern oder spielen Sie Golf auf einem der vielen wunderschönen Plätze. Die Lage bietet zahlreiche Möglichkeiten für Sport und Abenteuer."
        },
        {
          number: "04",
          title: "Ein Ort in der Natur",
          description: "Werfen Sie einen Blick auf die Natur und genießen Sie die Aussicht auf die umliegende Landschaft. Montana Y Sol bietet Panoramablick und ist umgeben von wunderschönen Bergen und grünen Wäldern."
        }
      ]
    },
    impressionen: {
      label: "Galerie",
      title: "Impressionen",
      subtitle: "Innen- und Außenvisualisierungen",
      images: [
        { title: "Gesamtansicht Dachterrassen" },
        { title: "Innenhof mit Pool" },
        { title: "Pool & Mediterrane Gärten" },
        { title: "Straßenansicht" },
        { title: "Pool mit Treppe" },
        { title: "Outdoor Kino" },
        { title: "Dachterrasse mit Pool" },
        { title: "Bergpanorama" }
      ]
    },
    location: {
      label: "Lage & Vorteile",
      title: "Das echte",
      titleHighlight: "Mallorca",
      titleEnd: "erleben",
      features: [
        { title: "Andratx, Mallorca", description: "Im ursprünglichen Westen der Insel" },
        { title: "Nahe am Meer", description: "Wenige Minuten zu Buchten & Stränden" },
        { title: "Bergpanorama", description: "Umgeben von Bergen & grünen Wäldern" },
        { title: "Nachhaltig", description: "In mallorquinische Lebensart eingepasst" }
      ],
      activitiesLabel: "Aktivitäten in der Nähe",
      activities: ["Radfahren", "Wandern", "Golf", "Wassersport", "Tauchen", "Kultur"],
      regionTitle: "Die Region entdecken",
      lifestyleTitle: "Ihr Lifestyle"
    },
    contact: {
      label: "Kontakt",
      title: "Lassen Sie uns",
      titleHighlight: "sprechen",
      locationLabel: "Standort",
      emailLabel: "E-Mail",
      phoneLabel: "Telefon",
      form: {
        name: "Name",
        email: "E-Mail-Adresse",
        phone: "Telefonnummer",
        address: "Adresse",
        subject: "Betreff",
        message: "Nachricht",
        submit: "Absenden",
        success: "Danke für's Absenden!",
        successMessage: "Wir melden uns in Kürze bei Ihnen."
      }
    },
    footer: {
      description: "Der ultimative Sehnsuchtsort für alle, die einen Ort für Ruhe und einen Ausgangspunkt für Sport und Kultur suchen.",
      navigation: "Navigation",
      activities: "Aktivitäten",
      contact: "Kontakt",
      copyright: "Alle Rechte vorbehalten.",
      tagline: "Ein Projekt von 5 Dimensional",
      finalTagline: "Ihr Traumdomizil auf Mallorca"
    }
  },

  en: {
    nav: {
      highlights: "Highlights",
      impressionen: "Gallery",
      lage: "Location", 
      kontakt: "Contact",
      projekt: "Project"
    },
    hero: {
      title: "Montana Y Sol",
      subtitle: "Your Place of Longing",
      description: "Exclusive living in the original Andratx, just minutes from Mallorca's beautiful coves.",
      cta: "Discover",
      location: "Andratx, Mallorca",
      playVideo: "Play Video",
      priceRequest: "Price on Request"
    },
    about: {
      label: "About the Project",
      title: "Montana Y Sol",
      p1: "Montana Y Sol is located in the original town of Andratx, just minutes from beautiful coves and beaches of Mallorca. The project offers mountain panoramas and is surrounded by blooming gardens and green forests.",
      p2: "It's the perfect place for sports and adventure, such as cycling, hiking, and golf, as well as water sports and diving. Here you can experience the real Mallorca and enjoy the hospitality of the locals.",
      p3: "Montana Y Sol is operated sustainably and is perfectly integrated into the Mallorcan way of life.",
      cta: "Learn More"
    },
    highlights: {
      label: "Why Montana Y Sol",
      title: "The Ultimate",
      titleHighlight: "Destination",
      items: [
        {
          number: "01",
          title: "Authentic Island Life",
          description: "Experience the real Mallorca and enjoy the hospitality of the locals. Montana Y Sol is located in the heart of the popular southwest of the island, offering insight into the culture and traditions of Mallorca."
        },
        {
          number: "02",
          title: "A Place Near the Sea", 
          description: "Relax by the sea and enjoy the clean coves, beaches, and crystal-clear water. Our construction project is just a few minutes' drive from the unique coves and beaches."
        },
        {
          number: "03",
          title: "A Place for Adventure",
          description: "Explore the island by bike, go hiking, or play golf at one of the many beautiful courses. The location offers numerous opportunities for sports and adventure."
        },
        {
          number: "04",
          title: "A Place in Nature",
          description: "Take in the nature and enjoy the view of the surrounding landscape. Montana Y Sol offers panoramic views and is surrounded by beautiful mountains and green forests."
        }
      ]
    },
    impressionen: {
      label: "Gallery",
      title: "Impressions",
      subtitle: "Interior and Exterior Visualizations",
      images: [
        { title: "Rooftop Terraces Overview" },
        { title: "Courtyard with Pool" },
        { title: "Pool & Mediterranean Gardens" },
        { title: "Street View" },
        { title: "Pool with Stairs" },
        { title: "Outdoor Cinema" },
        { title: "Rooftop Terrace with Pool" },
        { title: "Mountain Panorama" }
      ]
    },
    location: {
      label: "Location & Benefits",
      title: "Experience the real",
      titleHighlight: "Mallorca",
      titleEnd: "",
      features: [
        { title: "Andratx, Mallorca", description: "In the original west of the island" },
        { title: "Near the Sea", description: "Minutes to coves & beaches" },
        { title: "Mountain Panorama", description: "Surrounded by mountains & green forests" },
        { title: "Sustainable", description: "Integrated into Mallorcan lifestyle" }
      ],
      activitiesLabel: "Nearby Activities",
      activities: ["Cycling", "Hiking", "Golf", "Water Sports", "Diving", "Culture"],
      regionTitle: "Discover the Region",
      lifestyleTitle: "Your Lifestyle"
    },
    contact: {
      label: "Contact",
      title: "Let's",
      titleHighlight: "Talk",
      locationLabel: "Location",
      emailLabel: "Email",
      phoneLabel: "Phone",
      form: {
        name: "Name",
        email: "Email Address",
        phone: "Phone Number",
        address: "Address",
        subject: "Subject",
        message: "Message",
        submit: "Send",
        success: "Thank you for submitting!",
        successMessage: "We will get back to you shortly."
      }
    },
    footer: {
      description: "The ultimate place of longing for those seeking a place of peace and a starting point for sports and culture.",
      navigation: "Navigation",
      activities: "Activities",
      contact: "Contact",
      copyright: "All rights reserved.",
      tagline: "A project by 5 Dimensional",
      finalTagline: "Your Dream Home in Mallorca"
    }
  },

  es: {
    nav: {
      highlights: "Destacados",
      impressionen: "Galería",
      lage: "Ubicación",
      kontakt: "Contacto",
      projekt: "Proyecto"
    },
    hero: {
      title: "Montana Y Sol",
      subtitle: "Mi Lugar Soñado",
      description: "Vida exclusiva en el auténtico Andratx, a pocos minutos de las hermosas calas de Mallorca.",
      cta: "Descubrir",
      location: "Andratx, Mallorca",
      playVideo: "Reproducir Video",
      priceRequest: "Precio a Consultar"
    },
    about: {
      label: "Sobre el Proyecto",
      title: "Montana Y Sol",
      p1: "Montana Y Sol se encuentra en el pueblo original de Andratx, a pocos minutos de las hermosas calas y playas de Mallorca. El proyecto ofrece panoramas de montaña y está rodeado de jardines florecientes y bosques verdes.",
      p2: "Es el lugar perfecto para el deporte y la aventura, como ciclismo, senderismo y golf, así como deportes acuáticos y buceo. Aquí puede experimentar la verdadera Mallorca y disfrutar de la hospitalidad de los locales.",
      p3: "Montana Y Sol opera de manera sostenible y está perfectamente integrado en el estilo de vida mallorquín.",
      cta: "Saber Más"
    },
    highlights: {
      label: "Por Qué Montana Y Sol",
      title: "El Destino",
      titleHighlight: "Definitivo",
      items: [
        {
          number: "01",
          title: "Vida Isleña Auténtica",
          description: "Experimente la verdadera Mallorca y disfrute de la hospitalidad de los locales. Montana Y Sol se encuentra en el corazón del popular suroeste de la isla, ofreciendo una visión de la cultura y tradiciones de Mallorca."
        },
        {
          number: "02",
          title: "Un Lugar Cerca del Mar",
          description: "Relájese junto al mar y disfrute de las calas limpias, playas y aguas cristalinas. Nuestro proyecto de construcción está a solo unos minutos en coche de las calas y playas únicas."
        },
        {
          number: "03",
          title: "Un Lugar para la Aventura",
          description: "Explore la isla en bicicleta, haga senderismo o juegue al golf en uno de los muchos campos hermosos. La ubicación ofrece numerosas oportunidades para el deporte y la aventura."
        },
        {
          number: "04",
          title: "Un Lugar en la Naturaleza",
          description: "Contemple la naturaleza y disfrute de las vistas del paisaje circundante. Montana Y Sol ofrece vistas panorámicas y está rodeado de hermosas montañas y bosques verdes."
        }
      ]
    },
    impressionen: {
      label: "Galería",
      title: "Impresiones",
      subtitle: "Visualizaciones Interiores y Exteriores",
      images: [
        { title: "Vista General Terrazas" },
        { title: "Patio con Piscina" },
        { title: "Piscina y Jardines Mediterráneos" },
        { title: "Vista de la Calle" },
        { title: "Piscina con Escaleras" },
        { title: "Cine al Aire Libre" },
        { title: "Terraza con Piscina" },
        { title: "Panorama de Montaña" }
      ]
    },
    location: {
      label: "Ubicación y Beneficios",
      title: "Experimenta la verdadera",
      titleHighlight: "Mallorca",
      titleEnd: "",
      features: [
        { title: "Andratx, Mallorca", description: "En el oeste original de la isla" },
        { title: "Cerca del Mar", description: "Minutos a calas y playas" },
        { title: "Panorama de Montaña", description: "Rodeado de montañas y bosques" },
        { title: "Sostenible", description: "Integrado en el estilo mallorquín" }
      ],
      activitiesLabel: "Actividades Cercanas",
      activities: ["Ciclismo", "Senderismo", "Golf", "Deportes Acuáticos", "Buceo", "Cultura"],
      regionTitle: "Descubre la Región",
      lifestyleTitle: "Tu Estilo de Vida"
    },
    contact: {
      label: "Contacto",
      title: "Hablemos",
      titleHighlight: "",
      locationLabel: "Ubicación",
      emailLabel: "Correo",
      phoneLabel: "Teléfono",
      form: {
        name: "Nombre",
        email: "Correo Electrónico",
        phone: "Número de Teléfono",
        address: "Dirección",
        subject: "Asunto",
        message: "Mensaje",
        submit: "Enviar",
        success: "¡Gracias por enviar!",
        successMessage: "Nos pondremos en contacto pronto."
      }
    },
    footer: {
      description: "El destino definitivo para quienes buscan un lugar de paz y un punto de partida para el deporte y la cultura.",
      navigation: "Navegación",
      activities: "Actividades",
      contact: "Contacto",
      copyright: "Todos los derechos reservados.",
      tagline: "Un proyecto de 5 Dimensional",
      finalTagline: "Tu Casa de Ensueño en Mallorca"
    }
  }
};

export default translations;
